module.exports = __webpack_public_path__ + "static/voile-797167cc394cfb6528753f5ff60ea929.png";